var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDesktopTower = function SvgIconDesktopTower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.5 19.25V4.75h7v14.5zm-.25-16.5A1.75 1.75 0 0 0 12.5 4.5v15c0 .966.784 1.75 1.75 1.75h7.5a1.75 1.75 0 0 0 1.75-1.75v-15a1.75 1.75 0 0 0-1.75-1.75zm2.625 3.375a1 1 0 1 0 0 2h2.25a1 1 0 1 0 0-2zM3 8.5a.5.5 0 0 0-.5.5v6.375a.5.5 0 0 0 .5.5h7.125a1 1 0 1 1 0 2H9.25v1.375h.875a1 1 0 1 1 0 2h-3.75a1 1 0 1 1 0-2h.875v-1.375H3a2.5 2.5 0 0 1-2.5-2.5V9A2.5 2.5 0 0 1 3 6.5h7.125a1 1 0 1 1 0 2zm12.875 2a1 1 0 0 1 1-1h2.25a1 1 0 1 1 0 2h-2.25a1 1 0 0 1-1-1m3.625 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconDesktopTower;